var _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01MInforCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-f6d102e2-1030-4401-9e9d-d1ed88efcd3b",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.25,85.7c-22.19,0-40.25-18.1-40.25-40.35S23.05,5,45.25,5s40.25,18.1,40.25,40.35-18.05,40.35-40.25,40.35ZM45.25,9.76c-19.57,0-35.5,15.97-35.5,35.59s15.93,35.59,35.5,35.59,35.5-15.97,35.5-35.59S64.82,9.76,45.25,9.76Z",
    fill: "#c8c8c6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "53.23 26.55 60.03 33.37 53.23 33.37 53.23 26.55",
    fill: "#c8c8c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,59.35v-21.98s-7.97,0-7.97,0c-2.2,0-3.99-1.79-3.99-4v-7.99s-13.96,0-13.96,0c-3.3,0-5.98,2.69-5.98,6v27.98c0,3.31,2.68,6,5.98,6h19.94c3.3,0,5.98-2.69,5.98-6ZM52.64,42.78l-7.97,7.99c-.39.39-.9.59-1.41.59s-1.02-.2-1.41-.59l-3.99-4c-.78-.78-.78-2.05,0-2.83s2.04-.78,2.82,0l2.58,2.58,6.56-6.58c.78-.78,2.04-.78,2.82,0,.78.78.78,2.05,0,2.83Z",
    fill: "#c8c8c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01MInforCw);
export default __webpack_public_path__ + "static/media/01_M-INFOR-CW.afff655b3c6b9e1111ad2a21fc8f036b.svg";
export { ForwardRef as ReactComponent };